<template>
    <div class="no-credits-type-1">
        <div class="content">
            <div class="h2 title">{{$t('components.no_credits_error.title')}}</div>
            <div class="p description">{{$t('components.no_credits_error.' + (hasSubscription ? isAdmin ? 'description_paid_admin' : 'description_paid_user' : isAdmin ? 'description_free_admin' : 'description_free_user'), { date: paid_to_time ? epochToDisplayDate(paid_to_time) : '[...]' })}}</div>
            <div class="bar pulse-animation"></div>
            <button class="btn-s-icon btn-1" v-if="!isAdmin" @click="routeToSubscriptions">
                <span>{{$t('components.no_credits_error.buttons.' + (hasSubscription ? 'upgrade' : 'start'))}}</span>
                <div class="icon-arrow-neg"></div>
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import { useAccountStore } from "@/stores/account";
import { epochToDisplayDate } from '@/utils/dates';

export default {
    name: "NoCredits",
    props: {
        hasSubscription: {
            type: Boolean,
            default: false
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(useAccountStore, ['paid_to_time']),
    },
    methods: {
        epochToDisplayDate,
        routeToSubscriptions() {
            this.$router.push({ name: 'subscriptions' });
        }
    },
}
</script>